import { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Checkbox, Typography, Alert } from "antd";
import Turnstile from "react-turnstile";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import { usePlatformAuth } from "../../context/PlatformAuthContext";
import { TURNSTILE_SITEKEY } from '../../services/config';

const { Title, Text } = Typography;

export const PlatformLogin = () => {
  const [email, setEmail]           = useState("");
  const [deviceId, setDeviceId]     = useState("");
  const [step, setStep]             = useState(1);
  const [otp, setOtp]               = useState("");
  const [trusted, setTrusted]       = useState(false);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const captchaRef = useRef();
  const navigate = useNavigate();
  const { login, isAuthenticated } = usePlatformAuth();

  useEffect(() => {
    let id = localStorage.getItem("deviceId");
    if (!id) { id = crypto.randomUUID(); localStorage.setItem("deviceId", id); }
    setDeviceId(id);
  }, []);

  useEffect(() => {
    if (isAuthenticated) navigate("/platform", { replace: true });
  }, [isAuthenticated, navigate]);

  const handleSendCode = async () => {
    setLoading(true); setError("");
    try {
      const res = await api.platform.sendCode({ email, deviceId, captcha: captchaToken });
      if (res.status === "success") setStep(2);
      else {
        setError(res.message || "No se pudo enviar el código.");
        if (captchaRef.current) captchaRef.current.reset();
        setCaptchaToken("");
      }
    } catch { setError("Error de red o servidor."); }
    setLoading(false);
  };

  const handleVerifyCode = async () => {
    setLoading(true); setError("");
    try {
      const res = await api.platform.verifyCode({ email, otp, deviceId, trusted });
      if (res.status === "success" && res.data.token) {
        login(res.data.token);
        navigate("/platform", { replace: true });
      } else {
        setError(res.message || "Código incorrecto o expirado.");
      }
    } catch { setError("Error de red o servidor."); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0f172a" }}>
      <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 8px 32px rgba(0,0,0,0.4)", width: "90%", maxWidth: 400, padding: 36 }}>
        <Text style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: "#64748b", display: "block", textAlign: "center", marginBottom: 4 }}>
          PLATFORM
        </Text>
        <Title level={4} style={{ textAlign: "center", marginBottom: 24 }}>Panel del sistema</Title>

        {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} />}

        {step === 1 && (
          <Form layout="vertical" onFinish={handleSendCode}>
            <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: 16 }}>
              Ingresá tu correo. Te enviamos un código para verificar tu identidad.
            </Text>
            <Form.Item name="email" rules={[{ required: true, type: "email", message: "Ingresá un correo válido" }]}>
              <Input size="large" placeholder="Correo electrónico" type="email"
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
              <Turnstile ref={captchaRef} sitekey={TURNSTILE_SITEKEY} onVerify={(t) => setCaptchaToken(t)} />
            </div>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}
              disabled={!email || !captchaToken} style={{ background: "#0f172a" }}>
              Enviar código
            </Button>
          </Form>
        )}

        {step === 2 && (
          <Form layout="vertical" onFinish={handleVerifyCode}>
            <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: 16 }}>
              Ingresá el código que enviamos a <strong>{email}</strong>.
            </Text>
            <Form.Item name="otp" rules={[{ required: true, message: "Ingresá el código" }]}>
              <Input size="large" placeholder="Código" maxLength={6}
                value={otp} onChange={(e) => setOtp(e.target.value)} />
            </Form.Item>
            <Form.Item>
              <Checkbox checked={trusted} onChange={(e) => setTrusted(e.target.checked)}>
                Confiar en este dispositivo
              </Checkbox>
            </Form.Item>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}
              style={{ background: "#0f172a" }}>
              Iniciar sesión
            </Button>
          </Form>
        )}
      </div>
    </div>
  );
};
